export default "/fonts/iu.svg?2e06b88f79d966371bc5ffe9f1eb04f0";